import React, { memo } from "react";
import styles from "accountOwner/pages/Scheduler/Scheduler.module.scss";

/**
 * Subtle "+" affordance for empty scheduler cells.
 * Hidden until the parent date cell is hovered (or focused); click opens
 * the Create Event/Shift workflow (handled by parent).
 *
 * @param {object} props
 * @param {() => void} props.onClick
 * @param {"plus" | "circle"} [props.variant="plus"] - "plus" for weekly staff grid; "circle" for daily empty area
 * @param {string} [props.className]
 * @param {string} [props.ariaLabel]
 */
function EmptySchedulerCellAdd({
  onClick,
  variant = "plus",
  className = "",
  ariaLabel = "Create event or shift",
}) {
  return (
    <button
      type="button"
      className={`${styles["empty-cell-add"]} ${
        variant === "circle" ? styles["empty-cell-add-circle"] : ""
      } ${className}`.trim()}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(e);
      }}
      aria-label={ariaLabel}
    >
      {variant === "circle" ? (
        <span aria-hidden="true">
          <svg
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="0.5"
              y="0.5"
              width="25"
              height="25"
              rx="12.5"
              stroke="#E5E7DF"
            />
            <path
              d="M12.9978 8V18"
              stroke="#587E85"
              stroke-width="1.42857"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M8 12.9978H18"
              stroke="#587E85"
              stroke-width="1.42857"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>
      ) : (
        <span aria-hidden="true">
          <svg
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="0.5"
              y="0.5"
              width="25"
              height="25"
              rx="12.5"
              stroke="#E5E7DF"
            />
            <path
              d="M12.9978 8V18"
              stroke="#587E85"
              stroke-width="1.42857"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M8 12.9978H18"
              stroke="#587E85"
              stroke-width="1.42857"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>
      )}
    </button>
  );
}

export default memo(EmptySchedulerCellAdd);
